var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "mb-3" }, [
    _vm.singleNotAvailable
      ? _c("div", { staticClass: "alert alert-warning" }, [
          _vm._v(
            "\n        Ezen a túrán kétágyas szobák vannak és nem tudunk lehetőséget biztosítani arra, hogy 1 fő egyedül fogaljon el egy kétágyas szobát.\n        Emiatt csak páros számú foglalás leadása lehetséges.\n        Ha páratlan létszámú foglalást szeretnél leadni, kérjük vedd fel velünk a kapcsolatot.\n    "
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("label", { attrs: { for: "number_of_guests" } }, [_vm._t("default")], 2),
    _vm._v(" "),
    _c(
      "select",
      {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.formData.number_of_guests,
            expression: "formData.number_of_guests",
          },
        ],
        staticClass: "form-select",
        attrs: {
          name: "number_of_guests",
          id: "number_of_guests",
          required: "",
        },
        on: {
          change: function ($event) {
            var $$selectedVal = Array.prototype.filter
              .call($event.target.options, function (o) {
                return o.selected
              })
              .map(function (o) {
                var val = "_value" in o ? o._value : o.value
                return val
              })
            _vm.$set(
              _vm.formData,
              "number_of_guests",
              $event.target.multiple ? $$selectedVal : $$selectedVal[0]
            )
          },
        },
      },
      [
        _c("option", { attrs: { value: "" } }, [
          _vm._v("\n            " + _vm._s(_vm.$t("choose")) + "\n        "),
        ]),
        _vm._v(" "),
        _vm._l(_vm.freePlaces, function (freePlace) {
          return _c("option", { domProps: { value: freePlace } }, [
            _vm._v("\n            " + _vm._s(freePlace) + "\n        "),
          ])
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }